export const dramaWorks = [
  {
    id: "d1",
    title: "长夜烬明",
    type: "drama",
    region: "中国大陆",
    year: 2026,
    rating: 8.6,
    genres: ["古装", "奇幻", "权谋"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20poster%20for%20an%20epic%20ancient%20Chinese%20fantasy%20drama%2C%20a%20lone%20armored%20warrior%20standing%20on%20a%20cliff%20beneath%20a%20crimson%20stormy%20sky%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20drifting%20mist%2C%20dramatic%20rim%20light%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-drama-d1-cover&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20fantasy%20landscape%2C%20a%20vast%20misty%20mountain%20range%20under%20a%20crimson%20sunset%20sky%2C%20a%20tiny%20warrior%20silhouette%20on%20a%20distant%20ridge%2C%20warm%20amber%20and%20deep%20red%20color%20grading%2C%20cinematic%20wide%20shot%2C%20detailed%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=cp-drama-d1-hero&orientation=landscape",
    synopsis:
      "大雍王朝末年，天象异变频发，长夜笼罩大地。少年将军顾云舟为查明家族被诬陷的真相，孤身潜入权力中心的锦衣司，却意外卷入了动摇朝野的\"烬明案\"。他在冷艳的锦衣司掌事苏晚棠与神秘术士青玄之间，逐渐拼凑出被掩埋十六年的秘密。随着调查深入，顾云舟发现这场横跨两代人的阴谋，竟与自己的身世密不可分。当真相与情义冲突，他必须在复仇与守护之间做出抉择。",
    shortIntro:
      "少年将军潜入锦衣司追查家族冤案，卷入动摇朝野的\"烬明案\"，身世之谜与朝堂权谋交织。",
    cast: ["陆沉舟", "苏晚棠", "顾青玄", "沈知白"],
    director: "陈望山",
    releaseDate: "2026-03-18",
    totalEpisodes: 40,
    status: "更新至第6集",
    heat: 9820,
    updatedAt: "2026-10-14",
    featured: true,
    highlight: "朝堂权谋与奇幻术法交织，第一集便有高能反转，画面质感与服化道广受好评。",
    episodes: [
      { no: 1, title: "长夜将至", summary: "顾云舟在家族旧宅中拿到一枚染血的铜印，天象骤变，他决定重返帝都。", duration: "45分钟" },
      { no: 2, title: "锦衣司", summary: "为潜入锦衣司，顾云舟接受了一场九死一生的考核，结识冷面掌事苏晚棠。", duration: "44分钟" },
      { no: 3, title: "烬明案卷", summary: "一份被封存的案卷出现在书阁深处，记载着十六年前的一场大火。", duration: "46分钟" },
      { no: 4, title: "术士青玄", summary: "神秘术士青玄以一句旧诗点破顾云舟的身世疑云，双方暗流涌动。", duration: "43分钟" },
      { no: 5, title: "灯下黑", summary: "众人以为的敌人竟是保护者，苏晚棠被迫在忠诚与真相之间选择。", duration: "45分钟" },
      { no: 6, title: "铜印之谜", summary: "铜印上的血纹指向一位早已\"身故\"的重臣，长夜阴谋初现端倪。", duration: "47分钟" },
    ],
  },
  {
    id: "d2",
    title: "星海拾光",
    type: "drama",
    region: "中国大陆",
    year: 2025,
    rating: 9.0,
    genres: ["科幻", "悬疑", "情感"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20drama%20poster%2C%20a%20lone%20astronaut%20silhouette%20facing%20a%20giant%20warm%20amber%20planet%20rising%20over%20a%20dark%20horizon%2C%20teal-free%20warm%20orange%20color%20grading%2C%20soft%20nebula%20glow%2C%20detailed%20digital%20painting%2C%20no%20text%2C%20vertical%20poster%20composition&width=600&height=800&seq=cp-drama-d2-cover&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20space%20station%20observatory%20overlooking%20a%20warm%20amber%20gas%20giant%20planet%2C%20glowing%20windows%2C%20star%20field%2C%20warm%20orange%20and%20gold%20color%20grading%2C%20wide%20sci-fi%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=cp-drama-d2-hero&orientation=landscape",
    synopsis:
      "近未来，人类在近地轨道建起\"拾光站\"，用改造过的射电阵列搜索宇宙深处的信号。天体物理学家林知遥在例行观测中捕捉到一段周期性脉冲，破译后却是一串无法解释的个人记忆——属于二十年前失踪的姐姐。为了追查信号来源，她与合作多年的工程师程野一同登上退役舱段，却发现站内的时间正在悄悄错乱。每一次通讯延迟，都将他们推向一个更深的真相：信号也许并非来自宇宙，而是来自他们自己。",
    shortIntro:
      "天体物理学家捕捉到一段藏在宇宙深处的信号，破译后却是姐姐二十年前的记忆，时间在空间站里开始错乱。",
    cast: ["林知遥", "程野", "苏澈", "叶岚"],
    director: "赵行舟",
    releaseDate: "2025-11-02",
    totalEpisodes: 36,
    status: "已完结",
    heat: 9140,
    updatedAt: "2026-10-09",
    featured: true,
    highlight: "硬核科幻设定搭配细腻亲情线，第六集的时间悖论反转被誉为年度最佳。",
    episodes: [
      { no: 1, title: "脉冲", summary: "林知遥在值班日志中记录下一段每 36 小时重复一次的怪异脉冲。", duration: "48分钟" },
      { no: 2, title: "拾光站", summary: "团队发现射电阵列的校准时间比地球快了整整 4 秒。", duration: "46分钟" },
      { no: 3, title: "旧录音", summary: "脉冲破译后是一段童年的家庭录音，说话的人却是失踪的姐姐。", duration: "47分钟" },
      { no: 4, title: "延迟", summary: "通讯延迟逐日增加，站内两名成员对同一天的记忆开始不同。", duration: "45分钟" },
      { no: 5, title: "退役舱段", summary: "林知遥与程野潜入被封锁的旧舱段，发现另一组观测记录。", duration: "49分钟" },
      { no: 6, title: "回响", summary: "真相浮现：信号的回声源竟来自他们自己尚未发生的选择。", duration: "52分钟" },
    ],
  },
  {
    id: "d3",
    title: "归途有你",
    type: "drama",
    region: "中国大陆",
    year: 2025,
    rating: 7.9,
    genres: ["都市", "家庭", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20poster%2C%20a%20young%20woman%20with%20a%20travel%20bag%20standing%20on%20a%20quiet%20country%20road%20at%20golden%20hour%2C%20warm%20amber%20and%20soft%20cream%20color%20grading%2C%20gentle%20sunlight%2C%20detailed%20digital%20painting%2C%20no%20text%2C%20vertical%20poster%20composition&width=600&height=800&seq=cp-drama-d3-cover&orientation=portrait",
    synopsis:
      "在城市打拼十二年的沈知夏因一场突如其来的裁员，带着满身疲惫回到故乡小镇。本想短暂停留的她，却被母亲留下的旧面馆\"绊\"住了脚步。为了不让母亲经营半生的招牌关闭，她决定试着把面馆重新开起来。在这个过程中，她遇见了回乡创业的老同学陆行，也重新认识了那些被自己忽略多年的邻里与亲情。归途漫长，她终于明白，有些答案不在远方的城市，而在回家的路上。",
    shortIntro:
      "被裁员的沈知夏回到故乡小镇，为守住母亲留下的旧面馆重新出发，在归途中找回亲情与勇气。",
    cast: ["沈知夏", "陆行", "周姨", "林小满"],
    director: "吴思远",
    releaseDate: "2025-06-20",
    totalEpisodes: 32,
    status: "已完结",
    heat: 7360,
    updatedAt: "2026-09-28",
    highlight: "烟火气十足的治愈群像剧，一碗面串联起小镇三代人的温情故事。",
    episodes: [
      { no: 1, title: "失业的电话", summary: "沈知夏在加班途中接到裁员通知，决定先回老家喘口气。", duration: "43分钟" },
      { no: 2, title: "老面馆", summary: "母亲留下的面馆落满灰尘，墙上的旧菜单让她驻足许久。", duration: "42分钟" },
      { no: 3, title: "第一位客人", summary: "重新开张第一天只来了一位客人，却是镇上最爱挑剔的老周。", duration: "44分钟" },
      { no: 4, title: "旧同学", summary: "回乡创业的陆行带来一批新食材，也带来一段没说完的往事。", duration: "43分钟" },
      { no: 5, title: "手艺", summary: "沈知夏反复练习母亲的手法，终于找回了记忆里的味道。", duration: "45分钟" },
      { no: 6, title: "留与走", summary: "城市的机会再次找上门，她必须决定留下还是离开。", duration: "44分钟" },
    ],
  },
  {
    id: "d4",
    title: "山河故梦",
    type: "drama",
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    genres: ["年代", "历史", "家族"],
    cover:
      "https://readdy.ai/api/search-image?query=Period%20family%20drama%20poster%2C%20an%20old%20trading%20house%20courtyard%20under%20warm%20amber%20lanterns%2C%20figures%20in%20traditional%20garb%20in%20the%20distance%2C%20nostalgic%20sepia%20and%20crimson%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=cp-drama-d4-cover&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20period%20view%20of%20an%20old%20Chinese%20merchant%20town%20at%20dusk%20with%20lanterns%20and%20tiled%20roofs%2C%20a%20misty%20river%20and%20distant%20mountains%2C%20nostalgic%20sepia%20and%20crimson%20color%20grading%2C%20cinematic%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=cp-drama-d4-hero&orientation=landscape",
    synopsis:
      "故事横跨三十余载，从民国末年的商号兴衰讲到新时代的家族重聚。乔家三代人在时代洪流中守着\"诚\"字招牌，也守着彼此。长子乔知远接掌家业时，正逢时局动荡；妹妹乔明蕙远赴海外求学，多年后带回的却是一份重建的想法与一段未了的遗憾。山河变迁，故梦犹在，一家人的聚散离合，映照出一座城与一个时代的记忆。",
    shortIntro:
      "商号乔家三代人横跨三十余年的兴衰故事，在时代洪流里守着一块\"诚\"字招牌与彼此。",
    cast: ["乔知远", "乔明蕙", "梁先生", "阿棠"],
    director: "郑铭川",
    releaseDate: "2024-12-01",
    totalEpisodes: 44,
    status: "已完结",
    heat: 8720,
    updatedAt: "2026-09-15",
    featured: true,
    highlight: "年代质感拉满，服化道与配乐共同还原旧时商埠，家族群像演绎动人。",
    episodes: [
      { no: 1, title: "商号", summary: "民国末年，乔家商号在动荡中迎来一次决定命运的抉择。", duration: "46分钟" },
      { no: 2, title: "接掌", summary: "长子乔知远被迫提前接下家业，面对的是空了一半的账本。", duration: "45分钟" },
      { no: 3, title: "远行", summary: "妹妹乔明蕙登上去往海外的船，留下一封没写完的信。", duration: "44分钟" },
      { no: 4, title: "守夜", summary: "一场大火考验着乔家的信誉，知远做出了出乎所有人意料的决定。", duration: "47分钟" },
      { no: 5, title: "归人", summary: "多年后明蕙归来，带来的却不只是重逢。", duration: "46分钟" },
      { no: 6, title: "招牌", summary: "风雨之后，乔家重新挂起那块刻着\"诚\"字的旧招牌。", duration: "48分钟" },
    ],
  },
  {
    id: "d5",
    title: "春日恋歌",
    type: "drama",
    region: "韩国",
    year: 2026,
    rating: 8.2,
    genres: ["爱情", "青春", "校园"],
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20youth%20drama%20poster%2C%20two%20young%20figures%20standing%20under%20a%20blooming%20tree%20in%20a%20schoolyard%2C%20warm%20peach%20and%20amber%20pastel%20color%20grading%2C%20petals%20in%20the%20air%2C%20detailed%20digital%20painting%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=cp-drama-d5-cover&orientation=portrait",
    synopsis:
      "转学生尹夏珠在音乐教室里第一次听见郑允熙的钢琴声，那是一个尚未完成的春天。两人因为校庆音乐剧被迫合作，从互不理解到彼此靠近，把各自的孤单写进了同一段旋律。毕业在即，一次关于未来的选择让他们不得不面对分离的可能。春日短暂，但有些喜欢会一直延长。",
    shortIntro:
      "转学生尹夏珠与钢琴少年郑允熙因校庆音乐剧结缘，把各自的孤单写进同一段春天旋律。",
    cast: ["尹夏珠", "郑允熙", "金敏在", "朴秀雅"],
    director: "李在勋",
    releaseDate: "2026-04-05",
    totalEpisodes: 16,
    status: "更新至第6集",
    heat: 8210,
    updatedAt: "2026-10-11",
    highlight: "细腻的青春氛围与原创配乐是最大亮点，被称\"最适合春天追的剧\"。",
    episodes: [
      { no: 1, title: "春天的转学生", summary: "尹夏珠转学第一天，误闯了郑允熙正在练习的音乐教室。", duration: "42分钟" },
      { no: 2, title: "未完成的曲", summary: "一段没有结尾的钢琴旋律，成为两人之间的第一个秘密。", duration: "41分钟" },
      { no: 3, title: "校庆音乐剧", summary: "因为一场音乐剧，被迫合作的他们开始认识彼此。", duration: "43分钟" },
      { no: 4, title: "雨夜排练", summary: "突如其来的大雨被困在排练室，心事第一次被说出口。", duration: "42分钟" },
      { no: 5, title: "误解", summary: "一段被误传的对话，让两人之间出现了第一道裂缝。", duration: "44分钟" },
      { no: 6, title: "春天的答案", summary: "在樱花落尽之前，他们需要为这段旋律写下结尾。", duration: "43分钟" },
    ],
  },
  {
    id: "d6",
    title: "沉默的证人",
    type: "drama",
    region: "中国香港",
    year: 2025,
    rating: 8.5,
    genres: ["悬疑", "犯罪", "律政"],
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20poster%2C%20a%20lone%20figure%20in%20a%20rain%20soaked%20alley%20under%20warm%20amber%20streetlight%2C%20long%20shadows%2C%20desaturated%20warm%20brown%20and%20crimson%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=cp-drama-d6-cover&orientation=portrait",
    synopsis:
      "一桩看似普通的入室盗窃案，因为唯一目击者的沉默而变得扑朔迷离。年轻检察官许朗坚信证据说话，却在庭前取证中发现，所谓\"沉默\"背后藏着一个被刻意保护的家庭。为揭开真相，他与资深调查记者陈可联手，顺着一条几乎被销毁的转账记录，追查到城市的另一面。当证人终于开口，许朗才意识到，有些真相需要以勇气为代价。",
    shortIntro:
      "一桩盗窃案因唯一目击者的沉默而扑朔迷离，检察官许朗追查真相，却发现沉默背后另有隐情。",
    cast: ["许朗", "陈可", "周警司", "阿杰"],
    director: "黄志明",
    releaseDate: "2025-09-12",
    totalEpisodes: 28,
    status: "已完结",
    heat: 7980,
    updatedAt: "2026-09-30",
    highlight: "律政与悬疑双线并行，法庭戏张力十足，反转层层递进。",
    episodes: [
      { no: 1, title: "沉默者", summary: "案件唯一目击者拒绝作证，许朗在案发现场发现一处不合常理。", duration: "44分钟" },
      { no: 2, title: "账本", summary: "一条几乎被销毁的转账记录，指向一个并不存在的公司。", duration: "43分钟" },
      { no: 3, title: "记者的直觉", summary: "调查记者陈可接手旧案报道，直觉告诉她事情没那么简单。", duration: "45分钟" },
      { no: 4, title: "保护", summary: "证人的沉默原来是一种保护，而代价远超想象。", duration: "44分钟" },
      { no: 5, title: "开庭", summary: "庭审现场一句意外的证词，让所有推论被推翻。", duration: "46分钟" },
      { no: 6, title: "开口", summary: "当真相与安全冲突，证人必须做出最后的选择。", duration: "47分钟" },
    ],
  },
  {
    id: "d7",
    title: "逆光而行",
    type: "drama",
    region: "中国大陆",
    year: 2024,
    rating: 8.0,
    genres: ["励志", "医疗", "都市"],
    cover:
      "https://readdy.ai/api/search-image?query=Inspiring%20medical%20drama%20poster%2C%20a%20determined%20young%20doctor%20standing%20in%20a%20hospital%20corridor%20flooded%20with%20warm%20morning%20light%2C%20backlit%20silhouette%2C%20warm%20amber%20and%20soft%20cream%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-drama-d7-cover&orientation=portrait",
    synopsis:
      "在急诊科轮转的住院医师顾南音，因为一次失败的抢救被质疑\"不够冷静\"。为了证明自己，她主动申请加入偏远县城的对口支援项目。在那里，她面对的不只是匮乏的设备与复杂的病例，还有一群对年轻医生缺乏信任的乡亲。一次次与时间赛跑的抢救中，顾南音渐渐明白，医者的成长从不只靠技术。她学会在逆光里，依然坚定前行。",
    shortIntro:
      "急诊科新人顾南音在一次次抢救挫败后主动支援基层，在与时间的赛跑中重新找回医者的初心。",
    cast: ["顾南音", "陆先声", "孙主任", "小林"],
    director: "何向东",
    releaseDate: "2024-08-08",
    totalEpisodes: 34,
    status: "已完结",
    heat: 6820,
    updatedAt: "2026-09-18",
    highlight: "真实感极强的医疗现场，主演为角色进行的专业训练获业内认可。",
    episodes: [
      { no: 1, title: "第一次失败", summary: "一场本可挽回的抢救，让顾南音第一次怀疑自己。", duration: "43分钟" },
      { no: 2, title: "支援名单", summary: "她主动在支援名单上写下自己的名字，决定去最需要的地方。", duration: "42分钟" },
      { no: 3, title: "初到", summary: "县城医院设备有限，老医生的一句话让她彻底清醒。", duration: "44分钟" },
      { no: 4, title: "信任", summary: "为了让一位老人接受治疗，她花了整整三天。", duration: "43分钟" },
      { no: 5, title: "与时间赛跑", summary: "一场突发的群体意外，考验整个医疗队的极限。", duration: "45分钟" },
      { no: 6, title: "逆光", summary: "面对又一次艰难抉择，她终于做出不留遗憾的决定。", duration: "44分钟" },
    ],
  },
  {
    id: "d8",
    title: "浮生微澜",
    type: "drama",
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    genres: ["古装", "爱情", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20romance%20drama%20poster%2C%20a%20seated%20figure%20in%20silk%20robes%20beside%20a%20lakeside%20pavilion%2C%20lotus%20leaves%2C%20warm%20coral%20and%20amber%20color%20grading%2C%20soft%20mist%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-drama-d8-cover&orientation=portrait",
    synopsis:
      "出身寒门的女官陆微澜凭借一手好字进入御前文书房，成为最不起眼的小吏。她本想借文书之职查明父亲旧案，却因一次代笔被权倾朝野的摄政王萧承弈盯上。两人从彼此试探到默契联手，在一封封奏折与密令之间，展开了一场没有硝烟的博弈。浮生流转，一点微澜也足以改变潮水的方向。",
    shortIntro:
      "寒门女官陆微澜为查父亲旧案进入御前文书房，却被摄政王盯上，两人从试探到联手博弈朝局。",
    cast: ["陆微澜", "萧承弈", "宁公公", "柳尚仪"],
    director: "沈砚书",
    releaseDate: "2026-05-22",
    totalEpisodes: 36,
    status: "更新至第6集",
    heat: 8460,
    updatedAt: "2026-10-13",
    highlight: "以\"文书博弈\"为切入的权谋新意，女主智商在线，弹幕口碑节节攀升。",
    episodes: [
      { no: 1, title: "小小女官", summary: "陆微澜以一纸好字入选文书房，开始她小心翼翼的第一步。", duration: "45分钟" },
      { no: 2, title: "代笔", summary: "一次替人代笔，让她意外撞见摄政王萧承弈的秘密。", duration: "44分钟" },
      { no: 3, title: "试探", summary: "萧承弈以一道看似寻常的公文，试探这个不起眼的女官。", duration: "46分钟" },
      { no: 4, title: "密令", summary: "一封被调换的密令，让两人第一次站到同一边。", duration: "45分钟" },
      { no: 5, title: "旧案", summary: "父亲旧案的关键卷宗出现，陆微澜终于摸到线索。", duration: "47分钟" },
      { no: 6, title: "微澜", summary: "小小的改动牵动朝局，众人始料未及的连锁反应就此展开。", duration: "46分钟" },
    ],
  },
];